/* eslint-disable no-console */
// src/utils/getNegociosCarteleria.js
import { client } from ".";

export const getNegociosCarteleria = async ({ pais }) => {
  try {
    const { data, error } = await client
      .from("negocios_carteleria")
      .select("*")
      .eq("pais", pais)
      .eq("eliminada", false);

    if (error) {
      console.error("Error trayendo cartelería:", error);
      throw error;
    }

    return data || [];
  } catch (err) {
    console.error("Error en getNegociosCarteleria:", err);
    return [];
  }
};
